import apiClient from './apiClient';

export type AlertSettings = {
  dealAlertsEnabled: boolean;
  unsubscribePath: string;
  watches: Array<{ dealId: string; enabled: boolean }>;
};

const alertsService = {
  settings(signal?: AbortSignal) {
    return apiClient.get<AlertSettings>('/api/alerts/settings', { signal }).then((response) => response.data);
  },
  setGlobal(dealAlertsEnabled: boolean) {
    return apiClient
      .patch<{ dealAlertsEnabled: boolean }>('/api/alerts/settings', { dealAlertsEnabled })
      .then((response) => response.data);
  },
  setDeal(dealId: string, enabled: boolean) {
    return apiClient
      .patch<{ dealId: string; enabled: boolean }>(`/api/alerts/deals/${dealId}`, { enabled })
      .then((response) => response.data);
  },
  unsubscribe(token: string) {
    return apiClient
      .post<{ ok: boolean; message: string }>('/api/alerts/unsubscribe', { token })
      .then((response) => response.data);
  },
};

export default alertsService;
